<template>
  <div class="hall-container">
    <div class="hall-inner">
      <div class="department">
        <span @click="changeSelect('departmentId')" :class="{ active: !select.departmentId }">全部部门</span>
        <span v-for="{ departmentId, departmentName } in departmentList" :key="departmentId"
          @click="changeSelect('departmentId', departmentId)" :class="{ active: departmentId === select.departmentId }">
          {{ departmentName }}</span>
      </div>
      <section>
        <div class="role" data-title="所属角色" v-if="!userRole">
          <div>
            <span v-for="{ roleId, roleName } in roleList" :key="roleId" @click="changeSelect('roles', roleId)"
              :class="{ active: roleId === select.roles }">{{ roleName }}</span>
          </div>
        </div>
        <div class="category" data-title="业务分类">
          <div>
            <span @click="changeSelect('categoryId')" :class="{ active: !select.categoryId }">全部</span>
            <span v-for="{ categoryId, categoryName } in categoryList" :key="categoryId"
              @click="changeSelect('categoryId', categoryId)" :class="{ active: categoryId === select.categoryId }">
              {{ categoryName }}</span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="result">
          <div id="service" v-for="item in serviceList" :key="item.employId"
            @click="$router.push(`guide?employId=${item.employId}&hall=/hall`)">
            <p>
              <i :class="`el-icon-${item.icon}`"></i>
              <span>{{ item.employName }}</span>
            </p>
            <div>
              <span>{{ item.departmentName }}</span>
              <span>{{ ['线下办理', '线上办理', ' 线上线下结合'][item.handleWay - 1] }}</span>
            </div>
          </div>
        </div>
        <el-pagination layout="prev,pager,next,total" :total="total" :current-page.sync="select.pageParam.current"
          :page-size.sync="select.pageParam.size" @size-change="getServiceList"
          @current-change="getServiceList"></el-pagination>
      </section>
    </div>
  </div>
</template>

<script>
import * as api from './api'
export default {
  name: 'Hall',
  data() {
    return {
      userRole: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userDict : null,
      roleList: [{
        roleId: undefined,
        roleName: '全部'
      }, {
        roleId: 1,
        roleName: '教职工'
      }, {
        roleId: 2,
        roleName: '学生'
      }, {
        roleId: 3,
        roleName: '访客'
      }],
      departmentList: [],
      categoryList: [],
      select: {
        pageParam: {
          current: 1,
          size: 21
        },
        status: 1
      },
      serviceList: [],
      total: 0
    }
  },
  async created() {
    const { data: { departmentList } } = await api.getDepartmentList()
    this.departmentList = departmentList
    const { data: { categoryList } } = await api.getCategoryList()
    this.categoryList = categoryList
    this.getServiceList()
  },
  methods: {
    async getServiceList() {
      if (this.userRole) this.select.roles = this.userRole == 0 ? 2 : this.userRole == 2 ? 1 : this.userRole == 4 ? 3 : ''
      const { data: { employList, total } } = await api.getServiceList(this.select)
      this.serviceList = employList
      this.total = total
    },
    changeSelect(type, id) {
      this.$set(this.select, type, id)
      this.getServiceList()
    }
  }
}
</script>

<style lang="scss" scoped>
.hall-container {
  min-height: calc(100vh - 363px);
  background: #fff;

  .hall-inner {
    width: var(--inner-width);
    margin: auto;
    padding: 50px 0 100px;
    display: flex;
    gap: 40px;

    .department {
      width: 250px;

      &::before {
        content: '所属部门';
        display: block;
        height: 60px;
        background: $mainColor;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        line-height: 60px;
        text-align: center;
      }

      span {
        display: block;
        height: 50px;
        background: #eee;
        color: #333;
        font-size: 14px;
        line-height: 50px;
        cursor: pointer;
        padding-left: 20px;
        border-bottom: 1px solid #fff;
        position: relative;

        &::before {
          content: '';
          width: calc(100% - 4px);
          height: 100%;
          position: absolute;
          right: 0;
          background: #fff;
          opacity: 0;
        }

        &.active {
          background: linear-gradient(to right, $mainColor, #fff);
          color: #fff;

          &::before {
            opacity: .4;
          }
        }
      }
    }

    section {
      flex: 1;

      .role {
        margin-bottom: 30px;
      }

      .role,
      .category {
        display: flex;
        gap: 20px;

        &::before {
          content: attr(data-title);
          color: #333;
          transform: translateY(8px);
          font-size: 18px;
        }

        div {
          flex: 1;
          display: flex;
          gap: 20px;
          flex-wrap: wrap;

          span {
            background: #eee;
            padding: 8px 20px;
            color: #888;
            border-radius: 17px;
            cursor: pointer;
            transition: 300ms ease-in-out;

            &.active {
              background: $mainColor;
              color: #fff;
            }
          }
        }
      }

      .divider {
        height: 1px;
        background: #d9d9d9;
        margin: 40px 0;
      }

      .result {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 25px;
      }

      .el-pagination {
        margin-top: 50px;
      }
    }
  }
}
</style>